// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1cEM4","error":"InputSecondary_error__WU4Ry","disabled":"InputSecondary_disabled__2ZJgP"};